import Vue from 'vue'
import athleteTransformer from './../../transformers/athlete'
import athletesTransformer from './../../transformers/athletes'
import teamsTransformer from './../../transformers/teams'
import store from './../../store'
import $ from 'jquery'
import {chain} from 'lodash'

// When the request fails
const failed = () => {
}

const getAthleteFromPPDB = (athleteId) => {
  const urlAthleteSearch = process.env.PPDB_API_LOCATION +'/cgi-bin/person?q='
  Vue.http.get(urlAthleteSearch + athleteId).then((response) => {
    let athlete = {}
    const $doc = $($.parseXML(response.data))
    $doc.find('pingry-person').each((key, value) => {
      const $person = $(value)
      athlete = {
        'constituent-id': $person.find('constituent-id').text(),
        'first-name': $person.find('first-name').text(),
        'last-name': $person.find('last-name').text(),
        'maiden-name': $person.find('maiden-name').text(),
        'middle-name': $person.find('middle-name').text(),
        'nickname': $person.find('nickname').text(),
        'suffix-1': $person.find('suffix-1').text(),
        'year': $person.find('primary-education-class-of-year').text(),
      }
    })
    getAthleteFromBynder(athletesTransformer.fetch(athlete))
  }, (response) => {
    failed(response)
  })
}

const getAthleteFromBynder = (athlete) => {
  const title = athlete.name || ''
  let subtitle = ''
  if (athlete.year) {
    subtitle = `Class of ${athlete.year}`
  }

  store.dispatch('setPage', {
    title,
    subtitle,
  })

  store.dispatch('setAthletes', athlete)

  store.dispatch('fetchPersons').then(() => {
    const person = store.getters.getPerson(athlete.id)

    let athleteTeams = []

    const athleteQueries = [
      Vue.http.get(`media/?collectionId=BC193DCB-C4F7-4BB8-AD1A7920A5DB583E&limit=500&propertyOptionId=${person.id}`),
    ]

    Vue.Promise.all(athleteQueries)
      .then(responses => Vue.Promise.all(responses.map(response => response.json())))
      .then(jsons => {
        let teamsInfo = jsons.map(json => teamsTransformer.fetch(json)).flat()
        teamsInfo = chain(teamsInfo)
          .sortBy('sortName')
          .uniqBy('id')
          .value()
        store.dispatch('getTeams', teamsInfo)
      })
  })
}

const getAthleteFromItemId = (itemId) => {
  Vue.http.get(`media/?id=${itemId}`)
    .then(response => response.json())
    .then(json => {
      const athlete = athleteTransformer.fetch(json)

      getAthleteFromPPDB(athlete.ppdbid)
    })
    .catch(failed)
}

export default (athleteId, hof) => {
  const isHof = (hof === 'hof')
  if (isHof) {
    getAthleteFromItemId(athleteId)
  } else {
    getAthleteFromPPDB(athleteId)
  }
}
